export default "__VITE_ASSET__BxgXcJdr__"